import { useState } from 'react';
import {
  StyledHeadingWrapper,
  StyledVoucherCard,
  StyledVoucherCardContent,
  StyledVoucherOverlay,
  StyledVoucherText,
} from './VoucherCard.styles';
import { useTranslations } from 'next-intl';
import Heading from '@atoms/Heading/Heading';
import Text from '@atoms/Text/Text';
import Button from '@atoms/Button/Button';
import { AxfoodExternalVoucher } from '@occ/api-client';
import VoucherModal from '../VoucherModal/VoucherModal';
import getVoucherType, { VoucherTypes } from '@helpers/getVoucherType';
import Br from '@atoms/Br/Br';

interface Props {
  voucher: AxfoodExternalVoucher;
  productType: OnlineOfflineProductType;
}

const VoucherCard = ({ voucher, productType }: Props) => {
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const t = useTranslations('vouchercard');
  const voucherType = getVoucherType(voucher);

  return (
    <>
      <StyledVoucherCard $productType={productType}>
        <StyledVoucherCardContent>
          {voucher.status !== 'Tillgänglig' && (
            <StyledVoucherOverlay>
              <Text type="label">{t('usedVoucher')}</Text>
            </StyledVoucherOverlay>
          )}
          <StyledHeadingWrapper>
            <Heading variant="h3">{t('title')}</Heading>
            <Heading variant="h3" color="darkRed">{`${voucher.discountValue}${
              voucher.discountType === 'Procent' ? '%' : 'kr'
            }`}</Heading>
          </StyledHeadingWrapper>
          <StyledVoucherText type="body" size="small">
            {voucher.minPurchaseAmount && voucher.minPurchaseAmount > 0
              ? `${t('minPurchaseAmount', { amount: voucher.minPurchaseAmount })} ${t('text')} ${voucher.expirationDate}`
              : `${t('text')} ${voucher.expirationDate}`}
          </StyledVoucherText>

          <Text type="body" size="small">
            {voucherType !== VoucherTypes.OMNI ? t(`channel.${voucherType}`) : <Br />}
          </Text>

          <Button
            variant="secondary-light-bg"
            onClick={() => {
              if (voucher.status === 'Tillgänglig') setShowVoucherModal(true);
            }}
          >
            {t('button')}
          </Button>
        </StyledVoucherCardContent>
      </StyledVoucherCard>
      {showVoucherModal && (
        <VoucherModal
          voucher={voucher}
          onClose={() => setShowVoucherModal(false)}
          onConfirm={() => setShowVoucherModal(false)}
        />
      )}
    </>
  );
};

export default VoucherCard;
